export const ticketsStatus = {
  OPEN: 'خوانده نشده',
  SEEN: 'در صف بررسی',
  CLOSED: 'بسته شده',
  WAITING_FOR_USER_RESPONSE: 'منتظر پاسخ شما',
  SPELL: 'در حال ابطال',
  ONGOING: 'در جریان'
}

export const statusForAdmin = {
  // IN_PROGRESS: 'در حال بررسی',
  CLOSED: 'بسته شده',
  WAITING_FOR_USER_RESPONSE: 'منتظر پاسخ شما',
  SPELL: 'در حال ابطال',
  SEEN: 'در صف بررسی',
}
